// extracted by mini-css-extract-plugin
export default {"lang-selector":"LangSelector_lang-selector__wlDK-"};